import { PDFDocument, rgb } from "pdf-lib";
import templateUrl from './template.pdf';

// Maps each schema key to the representative PDF field name used for
// highlight positioning in the preview pane.
export const SCHEMA_TO_PDF_FIELD = {
  date: "date", studentName: "studentName1", oen: "oen1", grade: "grade1",
  board: "board", daysAbsent: "daysAbsent", totalDaysAbsent: "totalDaysAbsent",
  teacher: "teacher", timesLate: "timesLate", totalTimesLate: "totalTimesLate",
  school: "school", address1: "address1", address2: "address2",
  principal: "principal", telephone: "telephone", boardInformation1: "boardInformation1",
  responsibility: "responsibility", organization: "organization",
  independentWork: "independentWork", collaboration: "collaboration",
  initiative: "initiative", selfRegulation: "selfRegulation",
  strengthsNextStepsLSWH: "strengthsNextSteps",
  languagePlan: "languageESLELD", languageResult: "languagePWD",
  frenchPlan: "frenchESLELD", frenchResult: "frenchPWD",
  nativeLanguage: "nativeLanguage",
  nativeLanguagePlan: "nativeLanguageESLELD", nativeLanguageResult: "nativeLanguagePWD",
  mathematicsPlan: "mathematicsESLELD", mathematicsResult: "mathematicsPWD",
  scienceAndTechnologyPlan: "scienceAndTechnologyESLELD", scienceAndTechnologyResult: "scienceAndTechnologyPWD",
  socialStudiesPlan: "socialStudiesESLELD", socialStudiesResult: "socialStudiesPWD",
  healthEducationPlan: "healthEducationESLELD", healthEducationResult: "healthEducationPWD",
  physicalEducationPlan: "physicalEducationESLELD", physicalEducationResult: "physicalEducationPWD",
  artsHeader: "artsHeader",
  arts1: "arts1", arts1Plan: "arts1ESLELD", arts1Result: "arts1PWD",
  arts2: "arts2", arts2Plan: "arts2ESLELD", arts2Result: "arts2PWD",
  arts3: "arts3", arts3Plan: "arts3ESLELD", arts3Result: "arts3PWD",
  arts4: "arts4", arts4Plan: "arts4ESLELD", arts4Result: "arts4PWD",
  optionalStudies: "optionalStudies",
  optionalStudiesPlan: "optionalStudiesESLELD", optionalStudiesResult: "optionalStudiesPWD",
  strengthsNextStepsSubjects: "strengthsNextStepsSubjects",
  boardInformation2: "boardInformation2",
}

// Schema keys whose PDF widgets appear on page 1 (all others are on page 2).
export const PAGE_1_SCHEMA_FIELDS = new Set([
  "date", "studentName", "oen", "grade", "board", "daysAbsent", "totalDaysAbsent",
  "teacher", "timesLate", "totalTimesLate", "school", "address1", "address2",
  "principal", "telephone", "boardInformation1",
  "responsibility", "organization", "independentWork", "collaboration",
  "initiative", "selfRegulation", "strengthsNextStepsLSWH",
])

// One representative PDF field per step - used to compute the scroll
// position in the preview pane when the user changes steps.
export const STEP_ANCHOR_FIELDS = {
  1: "studentName1",
  2: "board",
  3: "daysAbsent",
  4: "responsibility",
  5: "languagePWD",
  6: "artsHeader",
}

const val = (v) => (v == null || v === undefined ? "" : String(v));

const fill = async (pdfFormObject, highlightRect = null) => {
  // load pdf
  const existingPdfBytes = await fetch(templateUrl).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const pdfForm = pdfDoc.getForm();

  //Uncomment to display all pdfForm fields in console log
  // const fields = pdfForm.getFields();
  // fields.forEach((field) => {
  //   const type = field.constructor.name;
  //   const name = field.getName();
  //   console.log(`${name}`);
  // });
  // console.log(pdfFormObject);

  ////////////// FORM VARIABLES TO PDF FIELDS TRANSLATION
  var field;
  ////////// Variables on the LEFT are PDF Fields
  ////////// Variables on the RIGHT are Form Schema Variables

  field = pdfForm.getField("date");
  field.setText(val(pdfFormObject["date"]));
  field = pdfForm.getField("studentName1");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(8);
  field = pdfForm.getField("oen1");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(8);
  field = pdfForm.getField("grade1");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(8);
  field = pdfForm.getField("board");
  field.setText(val(pdfFormObject["board"]));
  field.setFontSize(8);
  field = pdfForm.getField("daysAbsent");
  field.setText(val(pdfFormObject["daysAbsent"]));
  field.setFontSize(8);
  field = pdfForm.getField("totalDaysAbsent");
  field.setText(val(pdfFormObject["totalDaysAbsent"]));
  field.setFontSize(8);
  field = pdfForm.getField("teacher");
  field.setText(val(pdfFormObject["teacher"]));
  field.setFontSize(8);
  field = pdfForm.getField("timesLate");
  field.setText(val(pdfFormObject["timesLate"]));
  field.setFontSize(8);
  field = pdfForm.getField("totalTimesLate");
  field.setText(val(pdfFormObject["totalTimesLate"]));
  field.setFontSize(8);
  field = pdfForm.getField("school");
  field.setText(val(pdfFormObject["school"]));
  field.setFontSize(8);
  field = pdfForm.getField("address1");
  field.setText(val(pdfFormObject["address1"]));
  field.setFontSize(8);
  field = pdfForm.getField("address2");
  field.setText(val(pdfFormObject["address2"]));
  field.setFontSize(8);
  field = pdfForm.getField("principal");
  field.setText(val(pdfFormObject["principal"]));
  field.setFontSize(8);
  field = pdfForm.getField("telephone");
  field.setText(val(pdfFormObject["telephone"]));
  field.setFontSize(8);
  field = pdfForm.getField("boardInformation1");
  field.setText(val(pdfFormObject["boardInformation1"]));
  field.setFontSize(8);

  field = pdfForm.getField("responsibility");
  field.setText(val(pdfFormObject["responsibility"]));
  field.setFontSize(8);
  field = pdfForm.getField("organization");
  field.setText(val(pdfFormObject["organization"]));
  field.setFontSize(8);
  field = pdfForm.getField("independentWork");
  field.setText(val(pdfFormObject["independentWork"]));
  field.setFontSize(8);
  field = pdfForm.getField("collaboration");
  field.setText(val(pdfFormObject["collaboration"]));
  field.setFontSize(8);
  field = pdfForm.getField("initiative");
  field.setText(val(pdfFormObject["initiative"]));
  field.setFontSize(8);
  field = pdfForm.getField("selfRegulation");
  field.setText(val(pdfFormObject["selfRegulation"]));
  field.setFontSize(8);
  field = pdfForm.getField("strengthsNextSteps");
  field.setText(val(pdfFormObject["strengthsNextStepsLSWH"]));
  field.setFontSize(8);
  field.enableMultiline();

  // SECOND PAGE
  field = pdfForm.getField("studentName2");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(9);
  field = pdfForm.getField("oen2");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(9);
  field = pdfForm.getField("grade2");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(9);

  field = pdfForm.getField("languagePWD");
  pdfFormObject["languageResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("languagePW");
  pdfFormObject["languageResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("languagePVW");
  pdfFormObject["languageResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("frenchPWD");
  pdfFormObject["frenchResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchPW");
  pdfFormObject["frenchResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchPVW");
  pdfFormObject["frenchResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("nativeLanguage");
  field.setText(val(pdfFormObject["nativeLanguage"]));
  field = pdfForm.getField("nativeLanguagePWD");
  pdfFormObject["nativeLanguageResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("nativeLanguagePW");
  pdfFormObject["nativeLanguageResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("nativeLanguagePVW");
  pdfFormObject["nativeLanguageResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("mathematicsPWD");
  pdfFormObject["mathematicsResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("mathematicsPW");
  pdfFormObject["mathematicsResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("mathematicsPVW");
  pdfFormObject["mathematicsResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("scienceAndTechnologyPWD");
  pdfFormObject["scienceAndTechnologyResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("scienceAndTechnologyPW");
  pdfFormObject["scienceAndTechnologyResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("scienceAndTechnologyPVW");
  pdfFormObject["scienceAndTechnologyResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("socialStudiesPWD");
  pdfFormObject["socialStudiesResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("socialStudiesPW");
  pdfFormObject["socialStudiesResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("socialStudiesPVW");
  pdfFormObject["socialStudiesResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("healthEducationPWD");
  pdfFormObject["healthEducationResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("healthEducationPW");
  pdfFormObject["healthEducationResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("healthEducationPVW");
  pdfFormObject["healthEducationResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("physicalEducationPWD");
  pdfFormObject["physicalEducationResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("physicalEducationPW");
  pdfFormObject["physicalEducationResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("physicalEducationPVW");
  pdfFormObject["physicalEducationResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("artsHeader");
  field.setText(val(pdfFormObject["artsHeader"]));

  field = pdfForm.getField("arts1");
  field.setText(val(pdfFormObject["arts1"]));
  field = pdfForm.getField("arts1PWD");
  pdfFormObject["arts1Result"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1PW");
  pdfFormObject["arts1Result"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1PVW");
  pdfFormObject["arts1Result"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts2");
  field.setText(val(pdfFormObject["arts2"]));
  field = pdfForm.getField("arts2PWD");
  pdfFormObject["arts2Result"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2PW");
  pdfFormObject["arts2Result"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2PVW");
  pdfFormObject["arts2Result"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts3");
  field.setText(val(pdfFormObject["arts3"]));
  field = pdfForm.getField("arts3PWD");
  pdfFormObject["arts3Result"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3PW");
  pdfFormObject["arts3Result"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3PVW");
  pdfFormObject["arts3Result"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts4");
  field.setText(val(pdfFormObject["arts4"]));
  field = pdfForm.getField("arts4PWD");
  pdfFormObject["arts4Result"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4PW");
  pdfFormObject["arts4Result"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4PVW");
  pdfFormObject["arts4Result"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("optionalStudies");
  field.setText(val(pdfFormObject["optionalStudies"]));
  field = pdfForm.getField("optionalStudiesPWD");
  pdfFormObject["optionalStudiesResult"] === "PWD" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesPW");
  pdfFormObject["optionalStudiesResult"] === "PW" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesPVW");
  pdfFormObject["optionalStudiesResult"] === "PVW" ? field.check() : field.uncheck();

  field = pdfForm.getField("strengthsNextStepsSubjects");
  field.setText(val(pdfFormObject["strengthsNextStepsSubjects"]));
  field.setFontSize(8);
  field.enableMultiline();
  // TODO (unsupported ) field = pdfForm.getField( teacherSignature
  // TODO (unsupported ) field = pdfForm.getField( principalSignature

  field = pdfForm.getField("languageESLELD");
  pdfFormObject["languagePlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("languageIEP");
  pdfFormObject["languagePlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("languageNA");
  pdfFormObject["languagePlan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("frenchESLELD");
  pdfFormObject["frenchPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchIEP");
  pdfFormObject["frenchPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchNA");
  pdfFormObject["frenchPlan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchCore");
  pdfFormObject["frenchPlan"] === "Core" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchImmersion");
  pdfFormObject["frenchPlan"] === "Immersion" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchExtended");
  pdfFormObject["frenchPlan"] === "Extended" ? field.check() : field.uncheck();

  field = pdfForm.getField("nativeLanguageESLELD");
  pdfFormObject["nativeLanguagePlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("nativeLanguageIEP");
  pdfFormObject["nativeLanguagePlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("nativeLanguageNA");
  pdfFormObject["nativeLanguagePlan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("mathematicsESLELD");
  pdfFormObject["mathematicsPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("mathematicsIEP");
  pdfFormObject["mathematicsPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("mathematicsFrench");
  pdfFormObject["mathematicsPlan"] === "French" ? field.check() : field.uncheck();

  field = pdfForm.getField("scienceAndTechnologyESLELD");
  pdfFormObject["scienceAndTechnologyPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("scienceAndTechnologyIEP");
  pdfFormObject["scienceAndTechnologyPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("scienceAndTechnologyFrench");
  pdfFormObject["scienceAndTechnologyPlan"] === "French" ? field.check() : field.uncheck();

  field = pdfForm.getField("socialStudiesESLELD");
  pdfFormObject["socialStudiesPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("socialStudiesIEP");
  pdfFormObject["socialStudiesPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("socialStudiesFrench");
  pdfFormObject["socialStudiesPlan"] === "French" ? field.check() : field.uncheck();

  field = pdfForm.getField("healthEducationESLELD");
  pdfFormObject["healthEducationPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("healthEducationIEP");
  pdfFormObject["healthEducationPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("healthEducationFrench");
  pdfFormObject["healthEducationPlan"] === "French" ? field.check() : field.uncheck();

  field = pdfForm.getField("physicalEducationESLELD");
  pdfFormObject["physicalEducationPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("physicalEducationIEP");
  pdfFormObject["physicalEducationPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("physicalEducationFrench");
  pdfFormObject["physicalEducationPlan"] === "French" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts1ESLELD");
  pdfFormObject["arts1Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1IEP");
  pdfFormObject["arts1Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1French");
  pdfFormObject["arts1Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1NA");
  pdfFormObject["arts1Plan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts2ESLELD");
  pdfFormObject["arts2Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2IEP");
  pdfFormObject["arts2Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2French");
  pdfFormObject["arts2Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2NA");
  pdfFormObject["arts2Plan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts3ESLELD");
  pdfFormObject["arts3Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3IEP");
  pdfFormObject["arts3Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3French");
  pdfFormObject["arts3Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("art3NA");
  pdfFormObject["arts3Plan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("arts4ESLELD");
  pdfFormObject["arts4Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4IEP");
  pdfFormObject["arts4Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4French");
  pdfFormObject["arts4Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4NA");
  pdfFormObject["arts4Plan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("optionalStudiesESLELD");
  pdfFormObject["optionalStudiesPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesIEP");
  pdfFormObject["optionalStudiesPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesFrench");
  pdfFormObject["optionalStudiesPlan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesNA");
  pdfFormObject["optionalStudiesPlan"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("boardInformation2");
  field.setText(val(pdfFormObject["boardInformation2"]));
  field.setFontSize(8);

  // TOD0: add strengths and next steps field for subject improvment field
  pdfForm.flatten();

  if (highlightRect) {
    const { pageIndex, x, y, width, height } = highlightRect;
    const pages = pdfDoc.getPages();
    if (pages[pageIndex]) {
      pages[pageIndex].drawRectangle({
        x: x - 2,
        y: y - 2,
        width: width + 4,
        height: height + 4,
        color: rgb(0, 0.95, 0),
        opacity: 0.25,
        borderColor: rgb(0.9, 0.7, 0),
        borderWidth: 0,
        borderOpacity: 0.9,
      });
    }
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const filledPDFUrl = URL.createObjectURL(blob);
  console.log(filledPDFUrl);
  return filledPDFUrl;
};

export { fill };
